'use client';

import React from 'react';

export const IDEA_CHIPS: readonly string[] = [
  'We crash-land on an alien planet',
  "A treasure map in Grandad's attic",
  'Our dog gets superpowers',
  'A rocket in the back garden',
  'A dragon egg in the snow',
];

/** Tap-to-fill story ideas for the free-form path. Picking one replaces whatever is in the idea field. */
export default function IdeaChips({ onPick }: { onPick: (idea: string) => void }) {
  return (
    <div data-idea-chips="" className="flex flex-wrap gap-2" role="group" aria-label="Story idea suggestions">
      {IDEA_CHIPS.map((idea) => (
        <button
          key={idea}
          type="button"
          onClick={() => onPick(idea)}
          className="min-h-11 rounded-full border border-gray-300 bg-white px-3 py-1 text-sm text-gray-700 hover:bg-gray-50"
        >
          {idea}
        </button>
      ))}
    </div>
  );
}
